t = require('app/scripts/views/internal/teacup-with-helpers')('sticker_pack_selection_list')

module.exports = ->
  t.h2 ->
    t.text t.mustacheVar('displayName')

  t.div '.sticker-list.u-clearfix.js-sticker-list.u-relative'
